import _ from 'lodash';
import {
  VariantStateKey,
  buildSelectorToken,
} from '@packages/systems/style-legacy/selectors';

import type {
  PseudoStateKey,
  CustomNodeStateKey,
} from '@packages/systems/core/utils/StyleTypes';
import {SelectorToken} from '@packages/systems/style-legacy/rules';

export const getTokensForVariants = ({
  customNodeState,
  pseudoState,
  variantState,
}: {
  customNodeState: CustomNodeStateKey | null;
  pseudoState: PseudoStateKey | null;
  variantState: VariantStateKey | null;
}) => {
  const tokens: Array<SelectorToken | any> = [];

  if (customNodeState) {
    tokens.push(
      buildSelectorToken({
        customNodeState,
      })
    );
  }

  if (pseudoState) {
    tokens.push(
      buildSelectorToken({
        pseudoState,
      })
    );
  }

  if (variantState) {
    tokens.push(
      buildSelectorToken({
        variantState,
      })
    );
  }

  return tokens;
};

/**
 * Generates a simple GUID to identify an inner style rule.
 * @param  {String} blockGuid  A parent StyleBlock's _id, e.g. "abc123"
 * @param  {String} variantKey The variant key for the nested rule, e.g. "main" or "medium_hover"
 * @return {String}            A unique guid for the nested rule scoped to the parent block's _id, e.g. "abc123:medium_hover"
 */
export function createStyleRuleGuid(blockGuid: string, variantKey: string) {
  if (!blockGuid || !_.isString(blockGuid)) {
    throw new Error('Invalid blockGuid: ' + blockGuid);
  }
  if (!variantKey || !_.isString(variantKey)) {
    throw new Error('Invalid variantKey: ' + variantKey);
  }

  return blockGuid + ':' + variantKey;
}
